<template>
  <div>
    <Loading text="Loading group order..." v-if="!loadStatus" />
    <template v-if="loadStatus">
      <!-- <div class="arrow-link">
        <router-link :to="{ name: 'GroupOrderDetails' }">
          <span class="inter">Back</span>
        </router-link>
      </div> -->
      <div class="tiers">
        <component
          v-for="(tier, index) in groupOrderTiers"
          :key="tier.id"
          :sequence="index + 1"
          :groupOrderId="parseInt(id)"
          :tierId="tier.id"
          :name="tier.name"
          :tierQuantityLimit="tier.tierQuantityLimit"
          :tierItems="tier.tierItems"
          :defaultTiers="tier.defaultTiers"
          :selectionType="tier.selectionType || ''"
          :disabled="!tier.editable"
          :is="tier.componentType"
          @handlePrevStep="handlePrevStep"
          @handleNextStep="handleNextStep"
        ></component>
      </div>

      <div
        class="group-order-buttons"
        :class="{ disabled: groupOrderDetails.state === 'finalized' }"
      >
        <div class="button-left">
          <button
            class="whitebutton-gemnote whitebutton-gemnote--small"
            @click="addNewTier"
          >
            <span>+ ADD TIER</span>
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { layouts, progressStatus } from '../../helpers'
import GroupOrderGallery from './GroupOrderGallery'
import Tooltip from '../../components/Universal/ToolTipInfo.vue'
import i18n from '@/internatinalization/i18n'
import GroupOrderHeaderBanner from './GroupOrderHeaderBanner'
import GroupOrderTierHeader from './GroupOrderTierHeader'

export default {
  name: 'GroupOrderItemsSelection',
  props: ['id'],
  data: () => ({
    tooltips: {
      showPrices: {
        message: 'When turned on, product prices are shown to recipients.'
      },
      autoFinalize: {
        message:
          'When turned on, orders are created instantly as submissions are received. Any further action on orders cannot be taken'
      }
    },
    groupOrderStates: [
      'validating_recipients',
      'validating_subscription',
      'checking_inventory',
      'creating_orders',
      'finalized'
    ]
  }),
  components: {
    GroupOrderGallery,
    Tooltip,
    GroupOrderHeaderBanner,
    GroupOrderTierHeader
  },

  created() {
    this.$store.dispatch('groupOrder/getGroupOrder', this.id)
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
    this.$store.commit('groupOrder/CREATING_GROUP_ORDER_STEP', 3)
  },

  methods: {
    watchOrderFinalization() {
      if (
        this.groupOrderDetails.state !== 'pending' &&
        this.groupOrderDetails.state !== 'finalized' &&
        this.groupOrderDetails.state !== 'lock_finalisation'
      ) {
        this.$store.dispatch('groupOrder/getGroupOrderState', this.id)
      }
    },
    addNewTier() {
      this.$store.dispatch('groupOrder/addTierToGroupOrder', this.id)
    },
    async confirmSelection() {
      // NEW: check if its in edit mode then send straight to alter details. However if not disabled? send to card page.
      const isEdit = this.$route.fullPath.split('/').includes('edit')
      const isEditable = this.groupOrderTiers[0].editable
      let tierItemsToDelete = []

      if (
        this.selectedTierItemsToRemove &&
        this.selectedTierItemsToRemove.length
      ) {
        tierItemsToDelete = this.selectedTierItemsToRemove.filter(
          item =>
            !this.temporalSelectedItems.find(
              selectedItem => selectedItem.productId === item.productId
            )
        )
      }

      await this.$store.dispatch('groupOrder/handleMultipleItemTierItems', {
        groupOrderId: this.groupOrderDetails.id,
        tierItemsToDelete: tierItemsToDelete,
        itemsToAdd: this.temporalSelectedItems,
        id: this.id,
        isEdit,
        isEditable
      })
    },

    updateGroupOrder() {
      this.$store.dispatch('groupOrder/updateGroupOrder', {
        password: this.groupOrderDetails.password,
        customFields: this.groupOrderDetails.customFields,
        redirect: false,
        showPrices: !this.groupOrderDetails.showPrices
      })
    },
    instantFinalize() {
      if (this.groupOrderDetails.state === 'auto_finalising') {
        this.$store.dispatch(
          'groupOrder/stopInstantFinalize',
          this.groupOrderDetails.id
        )
      } else {
        this.$store.dispatch(
          'groupOrder/startInstantFinalize',
          this.groupOrderDetails.id
        )
      }
    },
    handleFinalizationError() {
      this.$store.dispatch(
        'notification/pushNotification',
        {
          type: 'error',
          messages: [i18n.t('grouporder.action.order-finalization-error')]
        },
        { root: true }
      )
    },
    showFinalizationError(message) {
      this.$store.dispatch(
        'notification/pushNotification',
        {
          type: 'error',
          messages: [message]
        },
        { root: true }
      )
    },
    handlePrevStep() {
      this.$store.commit(
        'groupOrder/CREATING_GROUP_ORDER_STEP',
        this.creatingGroupOrderStep - 1
      )
      this.$router.push({ name: 'GroupOrderCreate' })
    },
    handleNextStep() {
      if (this.disabledConfirm) {
        let message = []
        for (let index = 0; index < this.groupOrderTiers.length; index++) {
          const tier = this.groupOrderTiers[index]

          // Get the tier quantity limit
          let { tierQuantityLimit } = tier

          // Get the tier items length
          let tierItemsLength = tier.tierItems.length

          // check if quantity is equal to tier items length
          if (tierItemsLength >= tierQuantityLimit) {
            continue
          } else {
            message.push(`Tier ${index + 1} is incomplete.`)
            break
          }
        }

        this.$store.dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: message
          },
          { root: true }
        )
      } else {
        this.confirmSelection()
        this.$store.commit(
          'groupOrder/CREATING_GROUP_ORDER_STEP',
          this.creatingGroupOrderStep + 1
        )
      }
    }
  },
  computed: {
    loadStatus() {
      return progressStatus(this.loadGroupOrder)
    },
    isFinalizedDisabled() {
      return (
        this.groupOrderDetails.state === 'pending' ||
        this.groupOrderDetails.state === 'lock_finalisation'
      )
    },
    disabledConfirm() {
      let isDisabled = false
      for (let index = 0; index < this.groupOrderTiers.length; index++) {
        const tier = this.groupOrderTiers[index]

        // Get the tier quantity limit
        let { tierQuantityLimit } = tier

        // Get the tier items length
        let tierItemsLength = tier.tierItems.length

        // check if quantity is equal to tier items length
        if (tierItemsLength >= tierQuantityLimit) {
          continue
        } else {
          isDisabled = true
          break
        }
      }
      return isDisabled || this.updatingGroupTierItems
    },

    instantFinalizeState() {
      switch (this.groupOrderDetails.state) {
        case 'pending':
          return false
        case 'locked':
          return false
        case 'finalized':
          return false
        case 'auto_finalising':
          return true
        case 'validating_recipients':
          return true
        case 'validating_subscription':
          return true
        default:
          return false
      }
    },
    ...mapState({
      loadGroupOrder: state => state.groupOrder.loadGroupOrder,
      groupOrderDetails: state => state.groupOrder.groupOrderDetails,
      temporalSelectedItems: state => state.groupOrder.temporalSelectedItems,
      tempItemToRemove: state => state.groupOrder.tempItemToRemove,
      groupOrderTiers: state => state.groupOrder.groupOrderTiers,
      finalizingGroupOrder: state => state.groupOrder.finalizingGroupOrder,
      updatingGroupTierItems: state => state.groupOrder.updatingGroupTierItems,
      selectedTierItemsToRemove: state =>
        state.groupOrder.selectedTierItemsToRemove,
      creatingGroupOrderStep: state => state.groupOrder.creatingGroupOrderStep
    }),
    tooltipPosition() {
      if (this.innerWidth < 1000) {
        return 'bottom-start'
      }
      return 'right'
    }
  },
  mounted() {
    this.$cable.subscribe({
      channel: 'WorkersChannel'
    })
    this.watchOrderFinalization()
    console.log(900)
  },
  channels: {
    WorkersChannel: {
      connected() {
        console.log('Connected')
      },
      rejected() {
        console.log('rejected')
      },
      received(data) {
        if (data.error) {
          this.showFinalizationError(data.error)
          return
        }
        if (data.state === 'lock_finalisation') {
          this.handleFinalizationError()
        } else {
          this.$store.commit('groupOrder/SET_GROUP_ORDER_STATE', data.state)
        }
      },
      disconnected() {
        console.log('disconnected')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.tool-tip {
  margin-bottom: 10px;
}

.group-order-name {
  display: flex;
  align-items: center;
  color: #24292c;
  margin-bottom: 1rem;

  span {
    font-weight: map-get($map: $heading-weights, $key: bold);
    font-size: 1.063rem;
  }
}

.toggle-price {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  gap: 1rem;
  font-size: 21px;

  .text-holder {
    width: 14%;
  }

  span {
    font-weight: 700;
    font-size: 0.875rem;

    .tip {
      margin-bottom: 2px;
      margin-left: 6px;
    }
  }
}

.toggle-finalize {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 21px;

  .text-holder {
    width: 14%;
  }

  span {
    font-weight: 700;
    font-size: 0.875rem;

    .tip {
      margin-bottom: 2px;
      margin-left: 6px;
    }
  }
}

.tiers {
  // margin-top: 3rem;
}

.group-order-buttons {
  display: flex;
  height: 8rem;
}

.button-left {
  .whitebutton-gemnote {
    font-size: 0.878rem;
    padding: 0 26px !important;
    font-weight: 400 !important;
    text-transform: unset;
    border: 1px solid #232220;
    background-color: #dfdad2;
    color: #232220;
  }
}

.button-right {
  grid-column-start: 5;
  grid-column-end: 8;
  justify-self: start;
  align-self: center;

  .button-gemnote {
    font-size: 0.938rem;
    padding: 0 20px;
    text-transform: unset;
  }
}
</style>

<style lang="scss">
input:disabled + .toggle-slider[data-v-409abe3b] {
  cursor: not-allowed !important;
}
</style>
